// extracted by mini-css-extract-plugin
export default {"header":"Header_header__cVEC0","right":"Header_right__BG8Au","popup":"Header_popup__nv7lQ","popup_item":"Header_popup_item__ur2L9"};